import { Injectable } from '@angular/core';
import { TreeviewSelection } from './treeview-item';

@Injectable({providedIn: 'root'})
export abstract class TreeviewI18n {
  abstract getText(selection: TreeviewSelection): string;
  abstract getAllCheckboxText(): string;
  abstract getFilterPlaceholder(): string;
  abstract getFilterNoItemsFoundText(): string;
  abstract getTooltipCollapseExpandText(isCollapse: boolean): string;
}

@Injectable({providedIn: 'root'})
export class DefaultTreeviewI18n extends TreeviewI18n {
  getText(selection: TreeviewSelection): string {
    if (selection.uncheckedItems.length === 0) {
      if (selection.checkedItems.length > 0) {
        return this.getAllCheckboxText();
      } else {
        return '';
      }
    }

    switch (selection.checkedItems.length) {
      case 0:
        return 'Select options';
      case 1:
        return selection.checkedItems[0].text;
      default:
        return `${selection.checkedItems.length} selecionados`;
    }
  }

  getAllCheckboxText(): string {
    return 'Selecione';
  }

  getFilterPlaceholder(): string {
    return 'Filtro';
  }

  getFilterNoItemsFoundText(): string {
    return 'Nenhum item encontrado';
  }

  getTooltipCollapseExpandText(isCollapse: boolean): string {
    return isCollapse ? 'Expand' : 'Collapse';
  }
}
